/**
 * @generated SignedSource<<3342d94111e312f5e870a13b4a24c460>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BannerContent$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"BannerV2BannerAnnouncement">;
  } | null;
  readonly " $fragmentType": "BannerContent";
};
export type BannerContent$key = {
  readonly " $data"?: BannerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BannerContent",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BannerV2BannerAnnouncement"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "fa7672939076a19bf4033b74dbae7c18";

export default node;
